import script from "./newServerModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./newServerModal.vue?vue&type=script&lang=ts&setup=true"

import "./newServerModal.vue?vue&type=style&index=0&id=54b902d8&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b902d8"]])

export default __exports__